import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CourseAssignmentLessonService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CourseAssignmentLesson');
	}

  
    loadAllLessonsForCourse(id: System.Guid): Observable<ePM.Logic.CourseAssignmentLesson[]> {
        return this.myBaseService.loadAll(this.url + "/" + id);
    }
    start(tempItem: ePM.Logic.CourseAssignmentLesson) : Observable<ePM.Logic.CourseAssignmentLesson> {
        return this.myBaseService.save(null, this.url + "/" + tempItem.CourseAssignmentLessonID);
    }

    finish(tempItem: ePM.Logic.CourseAssignmentLesson): Observable<ePM.Logic.CourseAssignmentLesson> {
        return this.myBaseService.save(null, this.url + "/Finish/" + tempItem.CourseAssignmentLessonID);
	}

	
}
				